(() => {
    class RemoveUserModalController {
        constructor(
            $scope,
            $uibModalInstance,
            roles,
            userId,
            displayName,
            contextName,
            removeUserByRoles
        ) {
            this.modalInstance = $uibModalInstance;
            $scope.closeModal = this.closeModal.bind(this)
            $scope.userName = displayName;
            $scope.contextName = contextName;
            $scope.showSelectRoleWarning = false;

            $scope.rolesOptions = this.resolveDistinctRoleOptions(roles);

            $scope.removeUserClicked = () => {
                const noRoleSelected = !$scope.rolesOptions.find(x => x.selected);
                $scope.showSelectRoleWarning = noRoleSelected;
                if (noRoleSelected) {
                    return;
                }

                const rolesToRemove = roles
                    .filter(r => {
                        if (!this.isRoleRemovable(r.RoleId)) {
                            return false;
                        }
                        const roleOption = $scope.rolesOptions.find(ro => ro.id === r.RoleId);
                        return !!roleOption
                            && roleOption.selected;
                    });

                removeUserByRoles(
                    userId,
                    rolesToRemove
                );
                this.closeModal()
            };

            const accountOwnerRole = $scope.rolesOptions
                .find(ro => ro.id === Dashboard.Models.RoleLookup.RestaurantAccountOwner);
            $scope.showRemoveAccountOwnerMessage = !!accountOwnerRole;

            $scope.canRemoveRole = this.isRoleRemovable;
        }

        resolveDistinctRoleOptions(roles) {
            const distinctRoles = [];
            roles.forEach(r => {
                if (distinctRoles.find(dr => dr.id === r.RoleId)) {
                    return;
                }
                distinctRoles.push({
                    selected: r.RoleId !== Dashboard.Models.RoleLookup.RestaurantAccountOwner,
                    name: r.Name,
                    id: r.RoleId
                });
            });
            return distinctRoles;
        }

        isRoleRemovable(roleId) {
            return roleId !== Dashboard.Models.RoleLookup.RestaurantAccountOwner
        }

        closeModal() {
            this.modalInstance.close();
        }
    }

    angular.module("dashboard")
        .controller(
            "RemoveUserModalController",
            [
                "$scope",
                "$uibModalInstance",
                "roles",
                "userId",
                "displayName",
                "contextName",
                "removeUserByRoles",
                RemoveUserModalController
            ]);
})();
